var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4748 18.9582H7.47477C2.94977 18.9582 1.01643 17.0248 1.01643 12.4998V7.49984C1.01643 2.97484 2.94977 1.0415 7.47477 1.0415H12.4748C16.9998 1.0415 18.9331 2.97484 18.9331 7.49984V12.4998C18.9331 17.0248 17.0081 18.9582 12.4748 18.9582ZM7.47477 2.2915C3.6331 2.2915 2.26643 3.65817 2.26643 7.49984V12.4998C2.26643 16.3415 3.6331 17.7082 7.47477 17.7082H12.4748C16.3164 17.7082 17.6831 16.3415 17.6831 12.4998V7.49984C17.6831 3.65817 16.3164 2.2915 12.4748 2.2915H7.47477Z",
    fill: "currentColor",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64143 18.9582C6.29977 18.9582 6.01643 18.6748 6.01643 18.3332V1.6665C6.01643 1.32484 6.29977 1.0415 6.64143 1.0415C6.9831 1.0415 7.26643 1.32484 7.26643 1.6665V18.3332C7.26643 18.6748 6.99143 18.9582 6.64143 18.9582Z",
    fill: "currentColor",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4747 12.7582C12.3163 12.7582 12.158 12.6999 12.033 12.5749L9.89968 10.4416C9.65801 10.1999 9.65801 9.7999 9.89968 9.55824L12.033 7.4249C12.2747 7.18324 12.6747 7.18324 12.9163 7.4249C13.158 7.66657 13.158 8.06657 12.9163 8.30824L11.233 9.9999L12.9247 11.6916C13.1663 11.9332 13.1663 12.3332 12.9247 12.5749C12.7997 12.6999 12.6413 12.7582 12.4747 12.7582Z",
    fill: "currentColor",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar);
export default __webpack_public_path__ + "static/media/sidebar.a8dac906db9117d0ff8df05aaf2c297b.svg";
export { ForwardRef as ReactComponent };